import classNames from "classnames";
import { useCallback, useContext, useEffect, useState } from "react";
import "./SlideDrawer.css";
import useCognitoHelper from "../../hooks/useCognitoHelper";
import { ReactComponent as CloseIcon } from "../../assets/closeIcon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/logout.svg";
import { useNavigate } from "react-router-dom";
import DrawerContent from "./DrawerContent";
import { UserContext } from "../../Providers/UserProvider";

interface SideDrawerProps {
  show: boolean;
  closeFunc: () => void;
}

const SideDrawer = ({ show, closeFunc }: SideDrawerProps) => {
  const { signOut } = useCognitoHelper();
  const { userSession } = useContext(UserContext);
  const navigation = useNavigate();
  const [styles, setStyles] = useState<string>("hidden");

  useEffect(() => {
    if (show) {
      setStyles(
        "side-drawer open relative bg-gray-50 overflow-y-auto border-l-2"
      );
    } else {
      setStyles("side-drawer relative  bg-gray-50 overflow-y-auto border-l-2");
    }
  }, [show]);

  const logoutHandler = useCallback(async () => {
    try {
      await signOut();
      navigation("/login");
    } catch (error) {
      console.error("Error during sign out:", error);
      // Handle the error here, e.g. show an error message to the user
    }
  }, [signOut, navigation]);

  const CloseButton = useCallback(
    () => (
      <div className="flex justify-start pl-3 pt-2">
        <div onClick={closeFunc}>
          <CloseIcon className="hover:rounded-full  cursor-pointer hover:bg-slate-300 stroke-primary w-6 ease-in-out hover:scale-110 duration-300  hover:p-1" />
        </div>
      </div>
    ),
    [closeFunc]
  );

  const WelcomeMessage = useCallback(
    () => (
      <div className="grid grid-cols-4 items-center pt-4">
        <div className="text-primary text-md font-bold  ml-4 col-span-3">
          Welcome
        </div>
        <div className="flex justify-end mr-16">
          <div className="cursor-pointer has-tooltip" onClick={logoutHandler}>
            <LogoutIcon className="w-6 stroke-primary hover:rounded-full hover:bg-slate-300 ease-in-out hover:scale-110 duration-300 hover:p-1" />
            <span className="tooltip rounded shadow-lg py-2 px-4 bg-black text-white  -translate-x-6 mt-2 text-xs">
              Logout
            </span>
          </div>
        </div>
      </div>
    ),
    [logoutHandler]
  );

  const UserDetails = useCallback(
    () => (
      <div className="text-primary text-2xl ml-4 font-extrabold">
        {userSession?.claims?.user?.firstName || ""}{" "}
        {userSession?.claims?.user.lastName}
      </div>
    ),
    [userSession]
  );

  return (
    <div className={classNames(styles)}>
      <CloseButton />
      <div>
        <WelcomeMessage />
        <UserDetails />
        <div>
          <DrawerContent />
        </div>
      </div>
      <span className="text-gray-50 justify-end  items-end flex h-auto m-auto text-xs hover:cursor-default mt-32"></span>
    </div>
  );
};
export default SideDrawer;
